import { render } from "./AppMain.vue?vue&type=template&id=3d7292de&ts=true"
import script from "./AppMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/voquanghoa/code/medicinal-plant/MedicinalPlant.Frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/AppMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d7292de"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d7292de', __exports__)) {
    api.reload('3d7292de', __exports__)
  }
  
  module.hot.accept("./AppMain.vue?vue&type=template&id=3d7292de&ts=true", () => {
    api.rerender('3d7292de', render)
  })

}


export default __exports__